import { HtmlTitle } from '@app/components/html';
import { useToken } from '@app/core/auth/authentication/hooks/useToken';
import { useSplashBlocker } from '@app/core/splash/useSplashBlocker';
import { useQueryParam } from '@mi-front/core';
import { useEffect } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import { LoginErrorScreen } from './components/LoginErrorScreen';
import { useAutoAuth0Login } from './useAutoAuth0Login';

const loginTitleMessage = defineMessage({
  id: 'auth.loginScreen.title',
  defaultMessage: 'Login',
});

/**
 * Login entry: if already authenticated, leave /login; if login_error is present,
 * show a retry screen; otherwise redirect straight to Auth0 Universal Login.
 */
export function LoginPage() {
  const { $t } = useIntl();
  const redirectTo = useQueryParam('redirect_to');
  const loginError = useQueryParam('login_error');
  const token = useToken();
  const history = useHistory();

  const shouldAutoLogin = !token && !loginError;
  useAutoAuth0Login(shouldAutoLogin);
  useSplashBlocker('login', shouldAutoLogin);

  // Redirect only when TokenGate resolved a real access token (not stale isAuthenticated)
  useEffect(() => {
    if (token) {
      history.push(redirectTo || '/');
    }
  }, [token, redirectTo, history]);

  if (token) {
    return null;
  }

  return (
    <>
      <HtmlTitle text={$t(loginTitleMessage)} />
      {loginError ? <LoginErrorScreen /> : null}
    </>
  );
}
